
import React, { Component } from 'react'

class Person extends Component {
  render () {
    const p = this.props.p
    return (
      <ul className="ul-detections bb">
        <li className="name">
          {p.name} ({p.email})
        </li>
        <li className="btn">
          <button
            className="lnk-edit-lot"
            onClick={() => this.props.deletePerson(p, this.props.r)}
          >
          rimuovi
          </button>
        </li>
      </ul>
    )
  }
}

export default Person
